var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inventory-list"},[_c('category-wise-products',{attrs:{"padx":_vm.padx}}),_c('DashboardFooter',{staticClass:"mt-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }